import React from 'react';
import { Box } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { SERVICE_QUERY, SERVICE_QUERY_PROVIDER } from '../graphQL/queries';
import { useQuery } from '@apollo/react-hooks';
import { Loading } from '../../Loading';
import Service from '../Service';

const ServiceDetail = () => {
  let { workflowCode } = useParams();
  const { loading, data } = useQuery(SERVICE_QUERY, {
    variables: { workflowCode: workflowCode }
  });

  const { loading: providerLoading, data: providerData } = useQuery(SERVICE_QUERY_PROVIDER, {
    variables: { workflowCode: workflowCode }
  });
  return <Box>{providerLoading || loading ? <Loading /> : <Service providerData={providerData} data={data} />}</Box>;
};

export default ServiceDetail;
